import { useIntl } from 'react-intl';

import { useAnalytics } from '@/hooks/analytics';
import redirect from '@/utils/legacy/redirect';

import messages from './messages';
import { ContentWrapper, Cta, Disclaimer, Grid, Text, Wrapper } from './styles';

const Share = () => {
	const { formatMessage } = useIntl();
	const { logEventAsync } = useAnalytics();

	const onClick = async () => {
		await logEventAsync({
			eventName: 'Schools : Resources : CTA : Clicked',
			eventProps: {
				copy: messages.text.defaultMessage,
				type: 'button',
			},
		});
		redirect(
			'https://health.calm.com/book-a-demo/?utm_source=b2b-link-on-b2c&utm_medium=organic&utm_campaign=schools-page',
		);
	};

	return (
		<Wrapper>
			<Grid>
				<ContentWrapper>
					<Text>{formatMessage(messages.text)}</Text>
					<Cta backgroundColor="schoolBlue" onPress={onClick}>
						{formatMessage(messages.cta)}
					</Cta>
					<Disclaimer>{formatMessage(messages.text)}</Disclaimer>
				</ContentWrapper>
			</Grid>
		</Wrapper>
	);
};

export default Share;
